module.exports = __webpack_public_path__ + "static/media/promotional_11.fd3a373d.png";